import type { CreateExpenseInput, ExceptionExpenseInput, ExpenseCategoryView, ExpenseListQuery, ExpenseView, Page, RejectExpenseInput } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export type { ExpenseCategoryView, ExpenseView };

export function listExpenses(query: ExpenseListQuery): Promise<Page<ExpenseView>> {
  return api<Page<ExpenseView>>(`/expenses?${toListParams(query)}`);
}

export function listExpenseCategories(): Promise<ExpenseCategoryView[]> {
  return api<ExpenseCategoryView[]>('/expenses/categories');
}

/** The approver's queue: what the caller's roles let them decide right now, with the same filters, search, sort and paging as the list. */
export function listExpensesAwaitingMyApproval(query: ExpenseListQuery): Promise<Page<ExpenseView>> {
  return listExpenses({ ...query, scope: 'awaiting_my_approval' });
}

export function approveExpense(id: string): Promise<ExpenseView> {
  return api<ExpenseView>(`/expenses/${id}/approve`, { method: 'POST' });
}

export function rejectExpense(id: string, input: RejectExpenseInput): Promise<ExpenseView> {
  return api<ExpenseView>(`/expenses/${id}/reject`, { method: 'POST', body: JSON.stringify(input) });
}

export function approveExpenseAsException(id: string, input: ExceptionExpenseInput): Promise<ExpenseView> {
  return api<ExpenseView>(`/expenses/${id}/exception`, { method: 'POST', body: JSON.stringify(input) });
}

export function createExpense(input: CreateExpenseInput): Promise<ExpenseView> {
  return api<ExpenseView>('/expenses', { method: 'POST', body: JSON.stringify(input) });
}
